import { Box, Checkbox, Grid, Group, Image } from "@mantine/core";
import { paymentMethodTilesProps } from "../../../../types/types";
import '../retailerFinance.css';

export function PaymentMethodTiles(props: paymentMethodTilesProps) {
    return (
      <Grid.Col 
        sx={() => ({
          paddingBottom: "20px",
        })}
        key={props.name}
        md={6}
        lg={3}
        sm={12}
      >
        <Box 
          sx={(theme) => ({
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid",
            padding: "30px",
            marginRight: "10px",
            boxShadow: "-1px 1px 6px -1px #d1cfcf",
            height: "100%",
            borderRadius: theme.radius.sm,
            borderColor: theme.colors.gray[4],
          })}
          className={props.isDivDisabled ? 'disabled' : ''}
        >
          <Group>
            <Image width={35} height={35} src={props.image} />
          </Group>
          <Group
            sx={() => ({ 
                width: "65%",
                textAlign: "center",
                justifyContent: "center",
            })}>
            {props.name}
          </Group>
          

          <Group grow>
          
            <Checkbox
              sx={() => ({
                border: "1px solid #7DE5ED",
                borderRadius: "3px",
              })}
              styles={{ input: { border: "0px solid" }}}
              size="md"
              radius="xs"
              disabled = {props.disabled}
              checked={props.disabled ? props.disabled : (props.hasOwnProperty('checkedRetailers') ? (props.checkedRetailers === props.id) : (props.checkRetailerSharingDetails === props.id))}

              onChange={(event) => {
                if(props.hasOwnProperty('checkedRetailers') && props.setCheckedRetailers!=undefined){
                  if(props.checkedRetailers && props.checkedRetailers === props.id) {
                  props.setCheckedRetailers("");
                  }
                  else {
                  props.setCheckedRetailers(props.id);
                  }
              }else if(props.setCheckRetailerSharingDetails!=undefined){
                  if(props.checkRetailerSharingDetails && props.checkRetailerSharingDetails === props.id) {
                  props.setCheckRetailerSharingDetails("");
                  }
                  else {
                  props.setCheckRetailerSharingDetails(props.id);
                  }
              }
            }}
            ></Checkbox>
          </Group>
        </Box>
      </Grid.Col>
    );
  }